// The feedback category vocabulary, MIRRORED from Nexus.
//
// Feedback is not print vocabulary: the queue, the lifecycle and the category
// CHECK constraint all live in Nexus, so this list is a downstream copy and
// Nexus is the authority that validates it. It exists here only so the dialog
// can render the choices and the portal can reject a bad one with a clear
// message instead of forwarding it and reading back a 400.
//
// Adding a category means adding it in Nexus FIRST (its constraint and its
// labels), then here — never the reverse.
export const FEEDBACK_CATEGORIES = [
    'bug',
    'feature_request',
    'training_question',
    'data_issue',
    'permission_issue',
];
export function isFeedbackCategory(value) {
    return typeof value === 'string' && FEEDBACK_CATEGORIES.includes(value);
}
// How many screenshots one report may carry, and how large each may be once
// decoded. Deliberately tighter than Nexus's own ceiling: these ride base64
// inside the JSON body, so the encoded payload must clear the body limit on
// BOTH servers. Enforced in the dialog and again in the route.
export const MAX_FEEDBACK_SCREENSHOTS = 3;
export const MAX_FEEDBACK_SCREENSHOT_BYTES = 2_500_000;
export const MAX_FEEDBACK_SCREENSHOT_TOTAL_BYTES = 6_000_000;
// The JSON body limit both servers mount on the feedback path. 6MB of images
// encodes to ~8MB of base64, so this is that plus headroom for the text fields.
// The SAME literal is mounted on the Nexus side, in nexus_erp's
// packages/backend/src/app.ts on /api/erp/feedback — the portal must never
// accept a payload its receiver will refuse, so raising one means raising both.
export const FEEDBACK_JSON_BODY_LIMIT = '12mb';
//# sourceMappingURL=feedback.js.map